import axios from 'axios';
import URLs from '@/config/constants';

const headers = {
  'Content-Type': 'application/json; charset=UTF-8',
  Authorization: process.env.VUE_APP_TOKEN_TEMP,
};

const httpClient = axios.create({
  baseURL: URLs.PostLogin,
  headers,
  timeout: 60000,
});

const httpClientCI = axios.create({
  baseURL: URLs.PostValidateCI,
  headers,
  timeout: 60000,
});

export const login = async payload => httpClient.post('', payload).then((resp) => {
  if (resp.status === 200) { return Promise.resolve(resp); }
  if (resp.status === 204) {
    const responde = { response: { status: resp.status } };
    return Promise.reject(responde);
  }
  const responde = { response: { status: resp.status } };
  return Promise.reject(responde);
}).catch(err => Promise.reject(err));

export const validateCI = async payload => httpClientCI.post('', payload);
